module.exports = __webpack_public_path__ + "static/media/plan-gigas-libres-wom115.d25f6d41.svg";